export type SoilClassification = {
  hwsd: string;
  ipcc: string;
};

export const soilData: SoilClassification[] = [
  { hwsd: "Acrisol - AC", ipcc: "LAC - Soils" },
  { hwsd: "Albeluvisol - AB", ipcc: "HAC - Soils" },
  { hwsd: "Alisol - AL", ipcc: "HAC - Soils" },
  { hwsd: "Andosol - AN", ipcc: "Volcanic - Soils" },
  { hwsd: "Anthrosol - AT", ipcc: "LAC - Soils" },
  { hwsd: "Arenosol - AR", ipcc: "Sandy - Soils" },
  { hwsd: "Calcisol - CL", ipcc: "HAC - Soils" },
  { hwsd: "Cambisol - CM", ipcc: "HAC - Soils" },
  { hwsd: "Chernozem - CH", ipcc: "HAC - Soils" },
  { hwsd: "Cryosol - CR", ipcc: "LAC - Soils" },
  { hwsd: "Durisol - DU", ipcc: "LAC - Soils" },
  { hwsd: "Ferralsol - FR", ipcc: "LAC - Soils" },
  { hwsd: "Fluvisol - FL", ipcc: "LAC - Soils" },
  { hwsd: "Gleysol - GL", ipcc: "Wetland - Soils" },
  { hwsd: "Gypsisol - GY", ipcc: "HAC - Soils" },
  { hwsd: "Histosol - HS", ipcc: "Organic Soils" },
  { hwsd: "Kastanozem - KS", ipcc: "HAC - Soils" },
  { hwsd: "Leptosol - LP", ipcc: "HAC - Soils" },
  { hwsd: "Lixisol - LX", ipcc: "LAC - Soils" },
  { hwsd: "Luvisol - LV", ipcc: "HAC - Soils" },
  { hwsd: "Nitisol - NT", ipcc: "LAC - Soils" },
  { hwsd: "Phaeozem - PH", ipcc: "HAC - Soils" },
  { hwsd: "Planosol - PL", ipcc: "LAC - Soils" },
  { hwsd: "Plinthosol - PT", ipcc: "LAC - Soils" },
  { hwsd: "Podzol - PZ", ipcc: "Spodic - Soils" },
  { hwsd: "Regosol - RG", ipcc: "HAC - Soils" },
  { hwsd: "Solonchak - SC", ipcc: "HAC - Soils" },
  { hwsd: "Solonetz - SN", ipcc: "HAC - Soils" },
  { hwsd: "Stagnosol - ST", ipcc: "LAC - Soils" },
  { hwsd: "Technosol - TC", ipcc: "LAC - Soils" },
  { hwsd: "Umbrisol - UM", ipcc: "HAC - Soils" },
  { hwsd: "Vertisol - VR", ipcc: "HAC - Soils" }
];
